
import {initWebComponent} from "@/helpers/web-component-helper";
import $ from "jquery";
window.jQuery = $
// import * as bootstrap from "bootstrap";
import DataTable from 'datatables.net-bs5';
import 'datatables.net-select-bs5'
import {initDataTable} from "@/helpers/datatable/datatable-helper";
import {
    getDataTableFilterRows, getFeatureByData,
    initDataTableFilter,
    toggleFilterMark,
    zoomToFilterExtent
} from "@/helpers/datatable-filter-helper";
import {getActiveFilter, getActiveFilterUrl, getExportExtensions} from "@/helpers/filter/filter-helper";
import {initPopper} from "@/modules/popper";
import {getBySelector} from "@/helpers/element-helper";
import {getUrl} from "@/helpers/layer/info/layer-info-info-geometry-helper";
import {transform} from "ol/proj";
import {
    getBookmarkPresentationsByID,
    getProjectionByBookmarkPresentationID,
    removeLayersIncludes
} from "@/helpers/ol/ol-layer-helper";
import {showNotification} from "@/helpers/notification-helper";
import 'moment'
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {createGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper.js";

let table

export class LayerInfoFilterResultComponent extends HTMLElement {
    constructor(){
        super();

        const activeFilter = getActiveFilter()
        const url = getActiveFilterUrl()

        const template = document.createElement('template');
        const columns = []

        const markResult = activeFilter.Filter.filter.MarkResult

        let markResultVisible = ''
        let markResultChecked = ''
        switch (markResult) {
            case 0: // Niet markeren
                break;
            case 1:  // Niet markeren en verbergen
                markResultVisible = 'invisible'
                break;
            case 2: // Markeren
                markResultChecked = 'checked="checked"'
                break;
            case 3: // Markeren en verbergen
                markResultVisible = 'invisible'
                markResultChecked = 'checked="checked"'
                break;
        }

let innerHTML = `
<div class="card m-2">
    <div class="card-body pb-3">
        <div><h4 class="pt-3 mb-2">&nbsp;</h4>`

        console.log(activeFilter)

        if(!activeFilter.form.FormMutationID) {

            innerHTML += `
            <div class="float-left" style="margin-top: -30px;">
                <label class="switcher">
                    <input type="checkbox" class="switcher-input switcher-secondary" style="display:none;" id="chbFilterCheckbox">
                    <span class="switcher-indicator">
                      <span class="switcher-yes"></span>
                      <span class="switcher-no"></span>
                    </span>
                    <span class="switcher-label"></span> Selecteren
                </label>
            </div>`
        }

innerHTML += `          <div class="float-right"  style="margin-top:-30px"> 
                <label class="switcher ${markResultVisible}">
                    <input type="checkbox" class="switcher-input switcher-secondary" style="display:none;" id="chbFilterMark" ${markResultChecked}>
                    <span class="switcher-indicator">
                      <span class="switcher-yes"></span>
                      <span class="switcher-no"></span>
                    </span>
                    <span class="switcher-label"></span> Markeren
                </label>
                <button id="btnFilterViewFit" class="btn btn-sm btn-outline-secondary icon-btn text-transform-none popper-header" href="#">
                  <span class="fa fa-expand"></span>
                  <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                     Centreer resultaat
                    <div class="arrow" data-popper-arrow=""></div>
                  </div>
                </button>
`
        if(activeFilter.form.FormChartID) {
            innerHTML += ` <layer-info-filter-result-chart-button data-bookmark-presentation-id="${activeFilter.BookmarkPresentationID}"></layer-info-filter-result-chart-button>`
        }
        const exportExtensions = getExportExtensions(activeFilter)

        let visible = ''
        if(exportExtensions.length === 0) {
            visible = 'invisible'
        }

            innerHTML += `<div class="btn-group project-actions ${visible}">
                    <button class="btn btn-sm btn-outline-secondary icon-btn text-transform-none popper-header dropdown-toggle hide-arrow" data-bs-toggle="dropdown" aria-expanded="false">
                      <span class="fa fa-download"></span>
                      <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                         Download resultaat
                        <div class="arrow" data-popper-arrow=""></div>
                      </div>
                    </button>`


        if(activeFilter.Filter.filter.ShareFilter) {
            innerHTML += `<div class="btn-group project-actions">
                    <button id="btnFilterShare" class="btn btn-sm btn-outline-secondary icon-btn text-transform-none popper-header hide-arrow">
                      <span class="fa fa-share"></span>
                      <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                         Deel filter
                        <div class="arrow" data-popper-arrow=""></div>
                      </div>
                    </button>
                <input type="text" id="txtFilterShare" class="d-none">
               `
        }


        if(exportExtensions.length > 0) {
            innerHTML += `
                    <div class="dropdown-menu dropdown-menu-left dropdown-menu-md-left">
                      <h6 class="dropdown-header">Download als</h6>`
            getExportExtensions(activeFilter).map((exportExtension, key) => {
                // console.log(key)
                // console.log(exportExtension)
                innerHTML += `<a data-dt-button-key="` + key + `" class="dropdown-item dropdown-item-dt-button" href="#">` + exportExtension.export_extension.DisplayName + `</a>`
            })

            innerHTML += `</div>`
        }

        innerHTML += `
              </div>
            </div>      
        </div>  
        
        <table style="width: 100%" class="nowrap table table-hover dataTable no-footer" id="tblFilter">
            <thead>
                <tr>`

        activeFilter.form.form_attributes.map(formAttribute => {
            const attribute = formAttribute.attribute

            const column = {
                data: attribute.Attribute,
                render: function( data ) {
                    if(data === null || data === undefined) {
                        return ''
                    }
                    return data
                },
                id: attribute.ID
            }

            if(attribute.Type === 21) {
                column.visible = false
                column.searchable = false
            }

            innerHTML +=  `<th>` + attribute.Display + `</th>`
            columns.push(column)
        })

innerHTML +=  `</tr>
            </thead>
        </table>  
    </div>
</div>
`;

        template.innerHTML = innerHTML
        initWebComponent(this, template)

        initPopper()

        const dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
        dropdownElementList.map(function (dropdownToggleEl) {
            return new bootstrap.Dropdown(dropdownToggleEl)
        })

        table = initDataTableFilter(url, columns, 'tblFilter')

        this.querySelectorAll('.dropdown-item-dt-button').forEach( (element, key) => {
            element.addEventListener('click', () => {
                document.querySelector('layer-info-filter-result .dt-buttons').querySelectorAll('button').forEach( (childElement, childKey) => {
                    if(key === childKey) {
                        childElement.click()
                    }
                })
            })
        })

        this.querySelector('#btnFilterViewFit').addEventListener('click', () => {
            zoomToFilterExtent()
        })

        let selectedRows = []

        const chbFilterCheckbox = this.querySelector('#chbFilterCheckbox')

        if(chbFilterCheckbox) {
            chbFilterCheckbox.addEventListener('change', (e) => {

                if(e.target.checked) {
                    if(selectedRows.length > 0) {
                        table.rows(selectedRows.indexes()).select();
                        removeLayersIncludes('filter_select')
                        selectedRows.every(function (rowIdx, tableLoop, rowLoop) {
                            var data = this.data();

                            console.log(this.index())

                            const feature = getFeatureByData(data)
                            feature.projection = getProjectionByBookmarkPresentationID(activeFilter.BookmarkPresentationID)
                            createGeoJsonLayer(feature, 'filter_select' + this.index(), true, undefined, undefined, undefined, 10001)
                        });
                    }
                } else {
                    selectedRows = table.rows({ selected: true });
                    table.rows().deselect()
                    removeLayersIncludes('filter_select')
                }
                // getDataTAbleFilter
            })
        }

        this.querySelector('#chbFilterMark').addEventListener('click', (evt) => {
            toggleFilterMark(true)
        })
        const btnFilterShare = this.querySelector('#btnFilterShare')

        if(btnFilterShare) {
            btnFilterShare.addEventListener('click', (evt) => {
                // console.log('share')
                const featureIDs = []
                getDataTableFilterRows().map(data => {
                    // console.log(data)
                    featureIDs.push(data.featureid)
                })

                const bookmarkPresentation = getBookmarkPresentationsByID(activeFilter.BookmarkPresentationID)
                const mapCenter = window.map.getView().getCenter()
                const center = new transform(mapCenter, getViewProjectionName(), "EPSG:28992")
                const url = getUrl(center, bookmarkPresentation.DisplayName, featureIDs.join(','))
                // TODO
                // const url = getUrl(center, bookmarkPresentation.DisplayName, null, true)

                let copyText = this.querySelector("#txtFilterShare");
                copyText.value = url
                copyText.classList.remove('d-none')
                copyText.select();
                document.execCommand("copy");
                copyText.classList.add('d-none')

                showNotification('De link is gekopieërd naar het clipboard. Je kan het plakken met ctrl+v of rechtermuisknop.')
            })
        }
    }
}

export function resizeDataTableFilter(height = undefined) {
    if(table !== undefined) {
        table.columns.adjust()
        if(height) {
            getBySelector('layer-info-filter-result').querySelector('.dataTables_scrollBody').style['max-height'] = height + 'px'
        }
    }
}

